import React, { useState, useEffect } from 'react';
import { api } from '@/lib/api';
import { logger } from '@/lib/logger';
import { Lightning } from '@phosphor-icons/react';

export function AiUsageSection() {
  const [usage, setUsage] = useState(null);
  useEffect(() => {
    api.get('/users/me/ai-usage').then(r => setUsage(r.data)).catch((err) => logger.debug('ai-usage load failed:', err));
  }, []);
  return (
    <div className="bg-white border border-[#E5E7EB] rounded-lg p-6" data-testid="ai-usage-card">
      <h2 className="font-outfit text-lg font-semibold text-[#09090B] mb-3 flex items-center gap-2"><Lightning size={18} className="text-[#002FA7]" weight="fill" /> AI Credits Used</h2>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <p className="text-xs font-bold tracking-[0.12em] uppercase text-[#6B7280] font-ibm">Cost</p>
          <p className="font-outfit text-xl font-bold text-[#002FA7]">${Number(usage?.cost_usd || 0).toFixed(4)}</p>
        </div>
        <div>
          <p className="text-xs font-bold tracking-[0.12em] uppercase text-[#6B7280] font-ibm">Tokens</p>
          <p className="font-outfit text-xl font-bold text-[#09090B]">{(usage?.total_tokens || 0).toLocaleString()}</p>
        </div>
      </div>
      <p className="mt-2 text-xs text-[#6B7280] font-ibm">See <a href="/billing" className="text-[#002FA7] hover:underline">Billing</a> for full breakdown.</p>
    </div>
  );
}
